import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Plant.css';


function AddPlant() {
  const navigate = useNavigate();
  const [openTile, setOpenTile] = useState(null);

  const handleTileClick = (tile) => {
    setOpenTile(openTile === tile ? null : tile);
  };
  const [hypontechForm, setHypontechForm] = useState({
    serial_number: '',
    plant_id: '',
    country: '',
    hypontech_username: '',
    hypontech_password: '',
    city: '',
    battery_storage: '',
    east_pv_power: '',
    south_pv_power: '',
    west_pv_power: '',
    north_pv_power: '',
    model: '',
    installation_date: ''
  });
  const [hypontechMessage, setHypontechMessage] = useState('');

  const handleHypontechChange = (e) => {
    const { name, value } = e.target;
    setHypontechForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleHypontechSubmit = async (e) => {
    e.preventDefault();
    setHypontechMessage('');
    try {
      // Get JWT token from localStorage
      const token = localStorage.getItem('access_token');
      if (!token) {
        setHypontechMessage('No authentication token found. Please log in again.');
        return;
      }
      const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000';
      const payload = { ...hypontechForm };
      [
        'battery_storage',
        'east_pv_power',
        'south_pv_power',
        'west_pv_power',
        'north_pv_power'
      ].forEach((field) => {
        payload[field] = payload[field] === '' ? null : Number(payload[field]);
      });
      const response = await fetch(`${API_BASE}/hypontech/config`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });
      if (response.ok) {
        setHypontechMessage('Configuration saved successfully!');
        setHypontechForm({
          serial_number: '',
          plant_id: '',
          country: '',
          hypontech_username: '',
          hypontech_password: '',
          city: '',
          battery_storage: '',
          east_pv_power: '',
          south_pv_power: '',
          west_pv_power: '',
          north_pv_power: '',
          model: '',
          installation_date: ''
        });
        navigate('/userlogged');
      } else {
        setHypontechMessage('Failed to save configuration.');
      }
    } catch (error) {
      setHypontechMessage('Network error.');
    }
  };

  return (
    <div className="add-plant-page">
      <img
        src={require('./images/pv_m.png')}
        alt="PV Banner"
        className="image-main"
      />
      <div className="add-plant-intro">
        <h1>Dodaj instalacje.</h1>
        <p>Wybierz typ inwertera i wypełnij formularz, aby ustawić czas ładowania i rozładowywania baterii.
        Dla użytkoników premium dostępny model uczenia maszynowego, który na podstawie cen z PSE, ustawia
        najbardzie optymalny czas ładowania i rozładowywania magazynu energii.. 
        UserName and Password, Podaj dane do logowania do dostawcy invertera. 
        Jezeli hypontech podaj nazwe uzytkownika oraz haslo, ktorym logujesz sie do aplikacji hypontech. 
        Battery storage i zainstalowana moc na kazdym kierunku podaj w watach. Model: np. hypontech.</p>
      </div>
      <div className="inverter-options">
        {/* Hypontech Tile */}
        <div className="hypontech-tile" onClick={() => handleTileClick('hypontech')}>
          <h2>Hypontech</h2>
          <p>Wypełnij formularz dla Hypontech inverter.</p>
          {openTile === 'hypontech' && (
            <form style={{ marginTop: '20px', textAlign: 'left' }} onSubmit={handleHypontechSubmit} onClick={e => e.stopPropagation()}>
              <label>Serial Number:</label>
              <input type="text" name="serial_number" value={hypontechForm.serial_number} onChange={handleHypontechChange} style={{ width: '100%', marginBottom: '10px' }} />
              <label>Plant Id:</label>
              <input type="text" name="plant_id" value={hypontechForm.plant_id} onChange={handleHypontechChange} style={{ width: '100%', marginBottom: '10px' }} />
              <label>Country :</label>
              <input type="text" name="country" value={hypontechForm.country} onChange={handleHypontechChange} style={{ width: '100%', marginBottom: '10px' }} />
              <label>User Name:</label>
              <input type="text" name="hypontech_username" value={hypontechForm.hypontech_username} onChange={handleHypontechChange} style={{ width: '100%', marginBottom: '10px' }} />
              <label>Password:</label>
              <input type="text" name="hypontech_password" value={hypontechForm.hypontech_password} onChange={handleHypontechChange} style={{ width: '100%', marginBottom: '10px' }} />
              <label>City :</label>
              <input type="text" name="city" value={hypontechForm.city} onChange={handleHypontechChange} style={{ width: '100%', marginBottom: '10px' }} />
              <label>Battery Storage:</label>
              <input type="number" step="1" name="battery_storage" value={hypontechForm.battery_storage} onChange={handleHypontechChange} style={{ width: '100%', marginBottom: '10px' }} />
              <label>East PV Power:</label>
              <input type="number" step="1" name="east_pv_power" value={hypontechForm.east_pv_power} onChange={handleHypontechChange} style={{ width: '100%', marginBottom: '10px' }} />
              <label>South PV Power:</label>
              <input type="number" step="1" name="south_pv_power" value={hypontechForm.south_pv_power} onChange={handleHypontechChange} style={{ width: '100%', marginBottom: '10px' }} />
              <label>West PV Power:</label>
              <input type="number" step="1" name="west_pv_power" value={hypontechForm.west_pv_power} onChange={handleHypontechChange} style={{ width: '100%', marginBottom: '10px' }} />
              <label>North PV Power:</label>
              <input type="number" step="1" name="north_pv_power" value={hypontechForm.north_pv_power} onChange={handleHypontechChange} style={{ width: '100%', marginBottom: '10px' }} />
              <label>Model:</label>
              <input type="text" name="model" value={hypontechForm.model} onChange={handleHypontechChange} style={{ width: '100%', marginBottom: '10px' }} />
              <label>Installation Date:</label>
              <input type="date" name="installation_date" value={hypontechForm.installation_date} onChange={handleHypontechChange} required style={{ width: '100%', marginBottom: '10px' }} />
              <button type="submit" style={{ width: '100%', background: '#111', color: '#fff', padding: '8px', border: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '1em', cursor: 'pointer' }}>Submit</button>
              {hypontechMessage && <div style={{ marginTop: '10px', color: hypontechMessage.includes('successfully') ? 'green' : 'red' }}>{hypontechMessage}</div>}
            </form>
          )}
        </div>
        {/* Sofar Solar Tile */}
        <div className="hypontech-tile" onClick={() => handleTileClick('sofar')}>
          <h2>Sofar Solar</h2>
          <p>Fill in the form for Sofar Solar inverter configuration.</p>
          {openTile === 'sofar' && (
            <form style={{ marginTop: '20px', textAlign: 'left' }}>
              <label>Serial Number:</label>
              <input type="text" name="sofar_serial" style={{ width: '100%', marginBottom: '10px' }} />
              <label>Model:</label>
              <input type="text" name="sofar_model" style={{ width: '100%', marginBottom: '10px' }} />
              <label>Installation Date:</label>
              <input type="date" name="sofar_date" style={{ width: '100%', marginBottom: '10px' }} />
              <button type="submit" style={{ width: '100%', background: '#111', color: '#fff', padding: '8px', border: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '1em', cursor: 'pointer' }}>Submit</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddPlant;